import React from 'react';
import { StaticImage } from "gatsby-plugin-image"
import { FontAwesomeIcon } from '../../libs/fonts'

const Chip = (props) => {
	const { type, position, size, userColor, children } = props;

	let contents;
	let icon;
	let color = '';
	let chipSize = size === 'large' ? 'chip-large' : '';
	switch (type) {
		case 'remote':
			contents = 'Remote';
			icon = 'fa-solid fa-video';
			color = 'chip-orange';
			break;
		case 'workshop':
			contents = 'Workshop';
			icon = 'fa-solid fa-wrench';
			color = 'chip-blue';
			break;
		case 'bb':
			contents =
				<>
					<span>Remote - Powered by</span>
					<StaticImage
						src="../../images/assets/BB-logo.svg"
						loading="eager"
						alt="Broadcast Bridge"
						placeholder="none"
						height={22}
						style={{ marginLeft: 8 }}
					/>
				</>;
			icon = 'fa-solid fa-video';
			color = 'chip-broadcaster-red';
			chipSize = 'chip-large';
			break;
		default:
			contents = children;
			color = 'chip-orange';
	}

	return (
		<div
			className={
				`chip ${color} ${chipSize} ${position === 'absolute' ? 'chip-absolute' : 'chip-bottom'}`
			}
			style={{ backgroundColor: userColor }}
		>
			{icon ? (
				<FontAwesomeIcon
					icon={icon}
					style={{ marginRight: 8 }}
				/>
			) : null}
			{contents}
		</div>
	);
};

export default Chip;
